import React, { useState } from 'react';
import { unflatten } from 'flat';
import PropTypes from 'prop-types';
import { Modal, Button, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import ApiClient from 'ApiClient';
import withNotice from '../../../../../App/store/with-notice';
import TableCellContextMenu from '../../../../Influencer/Research/Prospects/components/custom/TableCellContextMenu';

const ContextMenuInList = ({
  record,
  meta,
  addNotice,
}) => {
  const vanityURL = unflatten(record);
  const [loading, setLoading] = useState(false);
  const [showRemoveVanityURL, setShowRemoveVanityURL] = useState(false);

  const handleDeleteDialogSubmit = async () => {
    setLoading(true);
    const api = new ApiClient();
    const response = await api.recordAction({
      resourceId: 'VanityUrl', actionName: 'delete', recordId: vanityURL.id,
    });
    meta.closeFunction();
    if (response.status === 200) {
      addNotice({
        message: 'The selected Vanity URL has been deleted',
        type: 'success',
      });
      meta.closeFunction();
    } else {
      console.log('Response to deleting Vanity URL', response);
      addNotice({
        message: 'Couldn\'t delete a selected Vanity URL',
        type: 'error',
      });
    }
    setShowRemoveVanityURL(!showRemoveVanityURL);
  };

  const goToPage = (url) => {
    const win = window.open(url, '_blank');
    win.focus();
  };

  const contextMenuOptions = [
    {
      label: 'Details',
      handler: () => goToPage(`/resources/VanityUrl/records/${vanityURL.id}/show`),
    },
    {
      label: 'Edit',
      handler: () => goToPage(`/resources/VanityUrl/records/${vanityURL.id}/edit`),
    },
    {
      label: 'Delete',
      handler: () => setShowRemoveVanityURL(!showRemoveVanityURL),
    },
  ];

  return (
    <>
      <TableCellContextMenu options={contextMenuOptions} />

      <Modal isOpen={showRemoveVanityURL} toggle={() => setShowRemoveVanityURL(!showRemoveVanityURL)} className="delete-modal" size="sm">
        <ModalHeader toggle={() => setShowRemoveVanityURL(!showRemoveVanityURL)} >
          Delete Vanity URL
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete the selected Vanity URL?<br />

        </ModalBody>
        <ModalFooter>
          <Button
            disabled={loading}
            className="btn-sm"
            color="danger"
            onClick={handleDeleteDialogSubmit}
          >
            Delete
          </Button>{' '}
          <Button
            disabled={loading}
            className="btn-sm"
            color="secondary"
            onClick={() => setShowRemoveVanityURL(!showRemoveVanityURL)}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

ContextMenuInList.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  addNotice: PropTypes.func.isRequired,
};

export default withNotice(ContextMenuInList);
